import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../core/services/language.service';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { LayoutComponent } from './layout.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FormsModule } from '@angular/forms';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { SharedModule } from '../shared/shared.module';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    LayoutComponent,
    HorizontalComponent,
    HorizontaltopbarComponent,
    FooterComponent,
    TopbarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    ScrollingModule,
    TranslateModule,
    FormsModule,
    SharedModule,
    DialogModule
  ],
  providers: [LanguageService]
})
export class LayoutsModule { }
